export default __webpack_public_path__ + "static/media/alienware-laptop.326e45b1.jpg";